export default "__VITE_ASSET__f815db91__"